.badge {
    padding: 0;
}
